import { html, LitElement, unsafeCSS } from "lit";
import { customElement, property } from "lit/decorators.js";
import styles from './Slider.scss?inline';

@customElement('app-slider')
export class Slider extends LitElement {
    static styles = [unsafeCSS(styles)]

    @property({ type: Number }) k_min: number = 0;
    @property({ type: Number }) k_max: number = 0;
    @property({ type: Number }) k_value: number = 0;
    @property({ type: Number }) k_step: number = 1;
    @property({ type: Boolean }) k_disabled: boolean = false;

    render() {
        const fraction = (this.k_value - this.k_min) / (this.k_max - this.k_min);

        const maxDigits = Math.max(String(this.k_min).length, String(this.k_max).length);

        const rightLabelChars = (maxDigits * 2) + 3;

        return html`
            <div class='slider-wrapper' style='--max-label-width: ${rightLabelChars}ch;'>
                <span>${this.k_min}</span>
                <input
                    .value=${this.k_value.toString()}
                    ?disabled=${this.k_disabled}
                    type='range'
                    min=${this.k_min}
                    max=${this.k_max}
                    step=${this.k_step}
                    @input=${this.handleInput}
                    style='--slider-fraction: ${fraction};'
                />

                <span class='label value-label'>
                    <span class='current'>${this.k_value} / ${this.k_max}</span>
                </span>
            </div>
        `
    }

    handleInput(e: Event) {
        const target = e.target as HTMLInputElement;
        this.k_value = Number(target.value);
        this.dispatchEvent(new CustomEvent('slider-change', {
            detail: { value: this.k_value },
            bubbles: true,
            composed: true,
        }))
    }
}